module.exports = __webpack_public_path__ + "static/media/physics_banner2.b052eeb9.jpg";